import { CheckIcon } from '@heroicons/react/20/solid/index';
import { mt, MutationData } from '@passionware/monads';
import { AlertCircle } from 'lucide-react';
import { ReactNode } from 'react';
import { LoadingSpinner } from 'v5/design-system/LoadingSpinner';
import { cn } from 'v5/platform/dom/cn';
import InlineToast from './InlineToast';

export function renderSpinnerMutation(
  mutation: MutationData<unknown, unknown>,
  idle: ReactNode = null,
  options?: {
    spinnerClass?: string;
    successClass?: ReactNode;
    errorClass?: string;
  }
) {
  return mt
    .journey(mutation)
    .initially(() => idle)
    .during(<LoadingSpinner className={options?.spinnerClass} />)
    .catch(e => (
      <InlineToast
        contentAfter={idle}
        delay={1000}
        className="flex flex-row items-center"
      >
        <AlertCircle className={cn('text-fg-danger', options?.errorClass)} />
      </InlineToast>
    ))
    .done(() => (
      <InlineToast
        contentAfter={idle}
        delay={2000}
        className="flex flex-row items-center"
      >
        <CheckIcon className={cn('h-5 text-primary', options?.successClass)} />
      </InlineToast>
    ));
}
